import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import SignaturePad from 'signature_pad';
import { ModalService } from 'src/app/services/modal.service';
import { getCapturedImage } from 'src/app/store/actions/shared.action';
import { AppState } from 'src/app/store/app.state';

@Component({
  selector: 'app-signature-pad',
  templateUrl: './signature-pad.component.html',
  styleUrls: ['./signature-pad.component.scss']
})
export class SignaturePadComponent implements OnInit, AfterViewInit {
  @ViewChild('signatureCanvas') signatureCanvas!: ElementRef<HTMLCanvasElement>;
  signaturePad!: SignaturePad;

  isSignatureEmpty: boolean = true;

  constructor(
    private modalService: ModalService,
    private store: Store<AppState>,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone
  ) { }

  ngOnInit(): void {

  }

  ngAfterViewInit() {
   this.signaturePad = new SignaturePad(this.signatureCanvas.nativeElement, {
      backgroundColor: 'rgba(255, 255, 255, 0)', // keep transparent
      penColor: 'black'
    });
    this.cdr.detectChanges();
    this.signaturePad.onEnd = () => {
    this.ngZone.run(() => {
      this.isSignatureEmpty = this.signaturePad.isEmpty();
    });
  };
  }

  clearSignature(): void {
    this.signaturePad.clear();
    this.isSignatureEmpty = true;
  }

  async saveSignature(): Promise<void> {
    if(!this.signaturePad.isEmpty()){

      const dataUrl = this.signaturePad.toDataURL();
      const filename = this.generateRandomString(10);
      const convertToFile = this.base64ToFile(dataUrl, filename);

      const payload = {
        file: convertToFile,
        base64: dataUrl
      }
      await this.store.dispatch(getCapturedImage({data: payload, captureType: 'camera'}));
      this.dismiss();
    }
  }

  generateRandomString(length: number): string {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  }

  base64ToFile(base64: string, filename: string): File {
    const arr = base64.split(',');
    const mimeMatch = arr[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : '';
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    // Extract extension from MIME type
    const extension = mime ? mime.split('/')[1] : '';
    const fullFilename = extension ? `${filename}.${extension}` : filename;

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], fullFilename, { type: mime });
  }

  dismiss(){
    this.modalService.hideCameraModal();
  }
}
